// Must stay first: installs the mock window.SETTINGS before any component module runs.
import "./dev-settings";

import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom/cjs/react-router-dom.min";

import App from "./app/app-entry";

// Keeps `npm start` usable on /launch: bb-ui-framework trips the benign
// "ResizeObserver loop completed with undelivered notifications" error, and CRA 5's
// dev overlay renders it full-screen over the page you're editing. Deferring
// callbacks by a frame keeps each observation pass clean so the browser stops
// reporting — suppression, not a fix, hence dev-only.
if (process.env.NODE_ENV === "development" && window.ResizeObserver) {
    const NativeResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class extends NativeResizeObserver {
        constructor(callback) {
            super((entries, observer) =>
                window.requestAnimationFrame(() => callback(entries, observer)),
            );
        }
    };
}

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root"),
);
